<template>
  <div id="wish-list" class="wish-list">
    <surface-post
      v-for="(post, index) in currentPosts"
      :key="post.cid"
      :index="index"
      :post="post"
      :edit="inlinePostEdit"
    />
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters, mapActions } from 'vuex'
import ConnectorsMixin from 'vuemixins/connectors_mixin'
import SortMixin from 'vuemixins/sort_mixin'
import SurfacePost from 'vuecomponents/surface_post'
import { $ } from 'bits/jquery'
import { scrollToPost, scrollNewPostIntoView } from 'surface/scroll_to_new_post'

export default {
  components: { SurfacePost },
  mixins: [ConnectorsMixin, SortMixin],
  data() {
    return {
      delayingUpdatePosts: false,
      currentPosts: [],
    }
  },
  computed: {
    ...mapState(['inlinePostEdit']),
    ...mapGetters('post', ['postEntitiesByCid', 'newestPostCid', 'sortedPosts']),
    ...mapGetters({
      format: 'format',
      canIWrite: 'canIWrite',
      newPostLocation: 'newPostLocation',
    }),
  },
  watch: {
    sortedPosts(value) {
      // Must do this so that vue won't rerender and crash shapeshift
      // TODO: remove jquery and eventually shapeshift. (see GridMixin)
      const $draggingElement = $(this.$el).find('.ss-dragged-child')
      if (!$draggingElement[0]) {
        this.currentPosts = value
      }
    },
    newestPostCid(postCid) {
      if (this.format === 'free') {
        scrollToPost('#wall-container', this.postEntitiesByCid[postCid])
      } else if (this.format === 'stream' || this.format === 'grid' || this.format === 'matrix') {
        if (this.newPostLocation === 'bottom' && this.inlinePostEdit) {
          this.$nextTick(() => {
            scrollNewPostIntoView()
          })
        }
      }
    },
  },
  mounted() {
    this.currentPosts = this.sortedPosts
    if ((this.format === 'stream' || this.format === 'matrix') && this.canIWrite) {
      this.initializePostsSort(({ postCid, previousCid, nextCid }) => {
        this.sortedPost({ postCid, sectionId: null, previousCid, nextCid })
      })
    }
  },
  methods: {
    ...mapActions('post', ['sortedPost']),
    onGridFinishDragging() {
      if (this.delayingUpdatePosts) {
        this.delayingUpdatePosts = false
        this.currentPosts = this.sortedPosts
      }
    },
  },
}
</script>
